<div [ngTemplateOutlet]="selected?.content"></div>
@if (!hideStepsIndicator) {
  <ol [class.hide]="hideWrapper" [ngClass]="['content ', goStepperClass]" class="steps-wrapper">
    @for (step of steps; track step; let i = $index) {
      <li class="step" [ngClass]="{'is-active': isSelected(i), 'hide': step.hideIndicator}"></li>
    }
  </ol>
}
